import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPropertyType.ts
var t = () => e("propertyType");
//#endregion
export { t as useTrPropertyType };
